import angular from 'angular';
import reportPackage from './reportPackage';
import editReportPackageDialog from '../dialog.editReportPackage';
import directive from './report-packages.directive';
import controller from './report-packages.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackages', [reportPackage, editReportPackageDialog])
  .directive('prReportPackages', directive)
  .controller('PRReportPackagesController', controller).name;

console.log('app.components.reports.packageReports.reportPackages created');
